import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface DownloadExternalAccountConfigCSVRequest {
  token: string;
  columnFilters?: string;
  sorting?: string;
  globalFilter?: string;
}

const downloadExternalAccountConfigCSV = async ({
  token,
  columnFilters,
  sorting,
  globalFilter,
}: DownloadExternalAccountConfigCSVRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/account/download-external-account-config`,
      {
        columnFilters,
        sorting,
        globalFilter,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);
    throw new Error(message);
  }
};

export default downloadExternalAccountConfigCSV;
